import { useState } from "react";
import {
  getAllETAPItemInstanceData,
  getAllItemInstanceData,
  getETAPItemInstanceData,
  getItemInstanceData,
  getItemsByList,
  getItemsByMdtETAP,
} from "../mdtApi/getData";
import { FilterType } from "../types/filters";

export const useItemData = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const loadData = async (filters: FilterType) => {
    setLoading(true);

    let reqData;
    if (filters.list === "all") {
      switch (filters.date_type) {
        case "all":
          reqData = await getAllItemInstanceData();
          break;
        case "exact":
          reqData = await getItemInstanceData(
            filters.exact_date,
            filters.exact_date
          );
          break;
        case "range":
          reqData = await getItemInstanceData(
            filters.start_date,
            filters.end_date
          );
          break;
      }
    } else {
      switch (filters.date_type) {
        case "all":
          reqData = await getItemsByList(filters.list.id);
          break;
        case "exact":
          reqData = await getItemsByList(
            filters.list.id,
            "",
            "",
            filters.exact_date,
            filters.exact_date
          );
          break;
        case "range":
          reqData = await getItemsByList(
            filters.list.id,
            "",
            "",
            filters.start_date,
            filters.end_date
          );
          break;
      }
    }

    setLoading(false);
    return reqData;
  };

  return { loadData, loading };
};

export const useETAPItemData = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const loadData = async (filters: FilterType) => {
    setLoading(true);

    let reqData;
    if (filters.project === "all") {
      switch (filters.date_type) {
        case "all":
          // ETAP TO DO: Check this? get all itmes from only ETAP
          reqData = await getAllETAPItemInstanceData();
          // alert(reqData);
          break;
        case "exact":
          reqData = await getETAPItemInstanceData(
            filters.exact_date,
            filters.exact_date
          );
          // alert(reqData);
          break;
        case "range":
          reqData = await getETAPItemInstanceData(
            filters.start_date,
            filters.end_date
          );
          // alert(reqData);
          break;
      }
    } else {
      // ETAP TO DO: change gettiemsbylist to getitemsbyproject
      switch (filters.date_type) {
        case "all":
          reqData = await getItemsByMdtETAP(filters.project.id);
          break;
        case "exact":
          reqData = await getItemsByMdtETAP(
            filters.project.id,
            filters.exact_date,
            filters.exact_date
          );
          break;
        case "range":
          reqData = await getItemsByMdtETAP(
            filters.project.id,
            filters.start_date,
            filters.end_date
          );
          break;
      }
    }

    setLoading(false);
    return reqData;
  };

  return { loadData, loading };
};
